import { AssetsFilesService } from '@/services/assetsFilesService/assets-files.service';
import { Component } from '@angular/core';
@Component({
  selector: 'app-cookies-approve-alert',
  templateUrl: './cookies-approve-alert.component.html',
  styleUrls: ['./cookies-approve-alert.component.css'],
})
export class CookiesApproveAlertComponent {

  accepted: boolean = true;
  message: string = '';
  unmount: boolean = false;

  get shouldShow(): boolean {
    if (!this.message) return true;
    return this.accepted;
  }

  constructor(
    private assetsFilesService: AssetsFilesService,
  ) {

    this.accepted = this.getStatusFromLocalStorage();
    if (this.accepted) {
      this.triggerUnmount();
    }
    this.assetsFilesService.getCookiesMessage().subscribe({
      next: (message) => {
        this.message = message;
      },
    });
  }

  acceptCookies() {
    this.accepted = true;
    this.saveStatusToLocalStorage(true);
    this.triggerUnmount();
  }

  triggerUnmount() {
    setTimeout(() => {
      this.unmount = true;
    }, 1500);
  }

  getStatusFromLocalStorage(): boolean {
    const stateFromLocalStorage = JSON.parse(localStorage.getItem('cookiesApprove') || '{}');
    if (stateFromLocalStorage) {
      if (Object.keys(stateFromLocalStorage).includes('accepted')) {
        return stateFromLocalStorage.accepted;
      }
    }
    return false;
  }

  saveStatusToLocalStorage(accepted: boolean) {
    localStorage.setItem('cookiesApprove', JSON.stringify({ accepted }));
  }
}
